/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when a service could not find a given model by it's `id`
 * @export
 * @class ModelNotFoundByIdError
 * @extends {Error}
 */
export class ModelNotFoundByIdError extends Error {
  /**
   * Creates an instance of ModelNotFoundByIdError
   * @param {string} message The Error `message`
   * @memberof ModelNotFoundByIdError
   */
  constructor(message) {
    super(message);
    this.name = `ModelNotFoundByIdError`;
  }
}

/**
 * Called when a service could not find a given model by it's `id`
 * @param {string} name The name of the `model`
 * @param {any} id The `id` of the model that could not be found
 * @returns {never} never
 */
const throwModelNotFoundByIdError = (name, id) => {
  throw new ModelNotFoundByIdError(
    stripIndent(`
    Could not find "${name}" with id: "${id}"
    `),
  );
};

export default throwModelNotFoundByIdError;
